import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import Container from 'packages/kakapo-ui-kit/components/grid/Container';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import IntercomTarget from 'packages/kakapo-ui-application/common/containers/IntercomTarget';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import CycleMomentsPreview from '../../../kakapo-ui-kit/components/cycles/CycleMomentsPreview';
import { PageTitle } from '../../../kakapo-ui-kit/components/common/Headings';
import HorizontalRule from '../../../kakapo-ui-kit/components/common/HorizontalRule';

import InboxTabBar from './InboxTabBar';
import InboxTasksContainer from './InboxTasksContainer';
import InboxPersonalSidebar from './InboxPersonalSidebar';

export function InboxPersonalContainerWithoutSidebar(props: { header?: boolean }) {
	const { t } = useTranslation();

	const showCycles = useFeature('2021.cycles');

	const viewer = useAuthenticatedUser();

	return (
		<IntercomTarget target="inbox" block>
			<Container fluid>
				<Column my={[2, 3, 3]}>
					{props.header !== false && (
						<Box mb={3}>
							<Flex
								flexDirection={['column', 'row', 'row']}
								alignItems={['flex-start', 'flex-end']}
							>
								<Box mb={2} flexGrow={1} flexShrink={1}>
									<PageTitle>{t('inbox.title', { name: viewer.firstName })}</PageTitle>
								</Box>
								<InboxTabBar />
							</Flex>
							<HorizontalRule />
						</Box>
					)}
					<Flex flexDirection={['column', 'column', 'column', 'row']}>
						<Box width={[12 / 12, 12 / 12, 12 / 12, 8 / 12]} flexDirection="column">
							{showCycles && <CycleMomentsPreview userID={viewer.id} />}

							<Box mt={4}>
								<InboxTasksContainer />
							</Box>
						</Box>

						<Box ml={[0, 0, 0, 4]} pt={[4, 4, 4, 0]} width={[12 / 12, 12 / 12, 12 / 12, 4 / 12]} flexShrink={0}>
							<InboxPersonalSidebar />
						</Box>
					</Flex>
				</Column>
			</Container>
		</IntercomTarget>
	);
}
